const NS = "SearchBar";
const CLS = "searchBar";
const WG = "." + CLS + "-";

import {WGSearchBar} from '../svelte.js'

export class SearchBar {

	constructor($el) {
		this.$el = $el;
	}

	init() {
		this.setSearchBar();
		this.handleToggle();
	}

	setSearchBar() {
		// const container = this.kid('sbContainer');
		const wg = $(this.$el);
		const container = wg.find('.sbContainer');
		const placeholder = wg.attr("data-placeholder");
		const api = wg.attr("data-api");
		const searchUrl = wg.attr("data-search-page");

		wg.hide();

		this.searchBar = new WGSearchBar({
			target: container[0],
			data: {
				placeholder: placeholder,
				apiEndpoint: api,
				searchUrl: searchUrl
			}
		});
	}

	handleToggle() {
		const wg = $(this.$el);
		const header = $('[data-wg="SiteHeader"]');
		$('.toggle-searchBar')
			.on('click', function(e) {
				header.toggleClass("is-searchBarOpen");
				if (header.hasClass('is-searchBarOpen')) {
					wg.slideDown('fast', function() {
						let winBottom = $(window).height();
						let wgOffset = wg.offset().top - $(window).scrollTop();
						let wgOuterHeight = wg.outerHeight();
						let posDiff = winBottom - wgOffset;
						
						// had to move the focus until after the animate to avoid browser's default scrolling behaviour on focus
						if (posDiff >= 0 && posDiff < wgOuterHeight) {
							let scrollAdjust = wgOuterHeight - posDiff;
							$('html, body').animate({
								scrollTop: $(window).scrollTop() + scrollAdjust,
							}, 300, "swing", function() {
								$(`${WG}input`).focus();
							});
						} else {
							$(`${WG}input`).focus();
						}
					});
				} else {
					wg.slideUp('fast');
					wg.hide();
				}
			});
	}


}
